import { Component, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { BehaviorSubject } from 'rxjs';

import { LockInfoResponse } from '../../../booking-api/client';
import { LockIdService } from '../../lock-id.service';

@Component({
  selector: 'app-header',
  imports: [Button, RouterLink],
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  protected lockInfo: BehaviorSubject<LockInfoResponse | undefined>;
  protected menuOpen = false;
  protected hideNavbar = false;
  private lastScrollTop = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;
    if (currentScroll > this.lastScrollTop && currentScroll > 50) {
      // Scrolling down
      this.hideNavbar = true;
    } else {
      // Scrolling up
      this.hideNavbar = false;
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  constructor(private lockIdService: LockIdService) {
    this.lockInfo = lockIdService.getLockInfo();
  }
}
